/**
 * Product image overrides
 *
 * Some products have non-ideal first images (e.g., technical tables/drawings).
 * This map lets us pick a better default image index for capturing + listing.
 */

const primaryImageIndexByHandle: Record<string, number> = {
  // Deante - first image is a compatibility table; show the real product photo.
  "sink-board-450x200x10": 1,
};

export const getPrimaryImageIndexOverride = (handle?: string | null): number | undefined => {
  if (!handle) return undefined;
  return primaryImageIndexByHandle[handle];
};
